// 조정계정
export const adjustmentAccountMap = {
  "21002900": "유동부채-미지급금-기타",
  "11010020": "미수금-임직원",
  "11012020": "선급금-국외운송비",
  "11012030": "선급금-보험료",
  "11012040": "선급금-수입관세",
  "11012050": "선급금-RPS",
  "11012060": "선급금-자재대",
  "11012900": "선급금-기타",
  "21000010": "유동부채-외상매입급-가스대",
  "21000020": "유동부채-외상매입급-외자",
  "21000040": "유동부채-외상매입급-석탄대",
  "21000050": "유동부채-외상매입급-유류대",
  "21000051": "유동부채-외상매입급-우드펠릿대",
  "21000060": "유동부채-외상매입급-기타",
  "21002020": "유동부채-미지급금-도급공사",
  "21002030": "유동부채-미지급금-자재대",
  "21002031": "유동부채-미지급금-국외운송비",
  "21002032": "유동부채-미지급금-보험료",
  "21002033": "유동부채-미지급금-수입관세",
  "21002040": "유동부채-미지급금-법인카드",
  "21002050": "유동부채-미지급금-임직원",
  "21002060": "유동부채-미지급금-송전설비건설비(금융리스부채)",
  "21002070": "유동부채-미지급금-송전설비임차료",
  "21002080": "유동부채-미지급금-송전설비이자비용",
  "21002100": "유동부채-미지급금-미납부가세",
  "21002130": "유동부채-미지급금-매입세금",
  "21002140": "유동부채-미지급금-부서",
  "21002150": "유동부채-미지급금-대여금",
  "21002180": "유동부채-외화미지급금",
  "21003173": "유동부채-미지급금-용역",
  "98000010": "전력기반기금-부가세거래처",
  "98000030": "사랑나눔이기금-부가세거래처",
};

// 지급조건
export const paymentMap = {
  PF07: "기산일+7일후 지급(펌뱅킹)",
  "D/P": "D/P(Document against Payment)",
  "L/C": "L/C at sight",
  "L/C2": "L/C 90 days after",
  "L/U1": "L/C Usance 90 Days",
  NW07: "네트워크론 7일 후 이체",
  PC00: "법인카드 대체(전월사용분 당월23일)",
  PC01: "법인카드 대체(월2회결제)",
  PC02: "법인카드 대체(전월사용분 당월27일)",
  PF00: "펌뱅킹 당일 이체",
  PF09: "기산일+9일후 지급(펌뱅킹)",
  PF14: "기산일+14일후 지급(펌뱅킹)",
  PF18: "기산일+18일후 지급(펌뱅킹)",
  PG00: "전자지로 납기일 지급",
  PH00: "익월15일/30일 분할지급(50:50)",
  PH15: "익월 15일 지급",
  PH31: "매월 31일 지급",
  PI00: "고지납부/기타이체/현금 당일 지급",
  PJ00: "RCMS 계좌이체 당일지급",
  PS07: "기산일+7일후 지급(물품구매 상생결제)",
  PSA7: "기산일+7일후 지급(노무비 상생결제)",
  PSB7: "기산일+7일후 지급(선급금 상생결제)",
  PSC7: "기산일+7일후 지급(공사대금(기성) 상생결제)",
  PT00: "외화 및 자금 당일 이체",
  PW00: "카드사용실적(월2회결제)",
  PW07: "협력회사 자금지원시스템(7일 후 이체)",
  PW23: "카드사용실적(전월사용분 당월23일)",
  PW27: "카드사용실적(전월사용분 당월27일)",
  PX00: "관세및수입부가세 월별납부",
  "T/T1": "T/T at Sight",
  "T/T2": "T/T net 30days",
  "T/T3": "T/T net 7days(after receiving invoice)",
  "T/T4": "T/T net 14days(after receiving invoice)",
  "T/T5": "T/T net 20days(after completion of delivery)",
  "T/T6": "T/T net 30days(after BL date)",
  "T/T8": "T/T in advance(사전승금)",
  T05: "익월 5일 지급",
  T07: "익월 7일 지급",
  T10: "익월 10일 지급",
  T11: "익월 11일 지급",
  T12: "익월 12일 지급",
  T14: "익월 14일 지급",
  T15: "익월 15일 지급",
  T19: "익월 19일 지급",
  T20: "익월 20일 지급",
  T21: "익월 21일 지급",
  T24: "익월 24일 지급",
  T25: "익월 25일 지급",
  T26: "익월 26일 지급",
  T27: "익월 27일 지급",
  T28: "익월 28일 지급",
  XX00: "지급무관",
};

// 지급방법
export const methodMap = {
  F: "펌뱅킹 이체",
  C: "Scheck (mit Scheckmanagement)",
  E: "현금지급",
  G: "전자지로",
  I: "고지납부/기타이체/현금 지급",
  J: "RCMS 계좌이체",
  L: "지급방법지정",
  N: "네트워크론 이체",
  P: "협력회사자금지원시스템(코램프)",
  S: "상생결제",
  T: "전신환",
  U: "외화계좌인출",
  W: "Wechsel",
};

// 원천세 코드
export const wtCodeMap = {
  "00": "원천세무관",
  "01": "사업소득(거주자 3%) ",
  "02": "기타소득(거주자 20%, 필요경비없음)",
  "03": "기타소득(거주자 20%, 필요경비 60%공제)",
  "05": "사업소득(비거주자 20%)",
  "06": "기타소득(비거주자 0%)",
  "07": "기타소득(비거주자 2%)",
  "08": "기타소득(비거주자 10%) ",
  "09": "기타소득(비거주자 20%) ",
  "10": "기타소득(비거주자 25%)",
  "11": "이자소득(비거주자 25%) ",
  "12": "이자소득(제한된 비거주자)",
  "13": "이자소득(장기 30%)",
  "14": "이자소득(실명미확인 35%)",
  "15": "이자소득(실명미확인 90%)",
  "16": "배당금(비과세)",
  "17": "배당급(일반 14%)",
  "18": "배당금(비거주자 25%)",
  "19": "배당금(제한된 비거주자) ",
  "20": "배당금(실명미확인 25%)",
  "21": "배당금(실명미확인 90%)",
};
